import { Button } from '@/components/ui/button';

/**
 * Travel "Quote and buy online" block.
 *
 * The buttons and the disclosure are INSEPARABLE by design: this single
 * component renders both, always together, so the disclosure can never appear
 * without the buttons and vice versa. Used on all seven travel pages and inside
 * the Get a Quote modal (Travel path).
 *
 * Props:
 *   superVisa  when true, appends the IRCC responsibility line to the disclosure
 *              (used on /travel-insurance/super-visa only).
 */
export const TravelQuoteOnline = ({ superVisa = false }) => {
  return (
    <div
      className="rounded-lg border border-neutral-200 bg-white p-6 sm:p-8"
      data-testid="travel-quote-online"
    >
      <h3 className="text-[22px] font-semibold text-neutral-900 mb-2" style={{ fontWeight: 600 }}>
        Quote and buy online
      </h3>
      <p className="text-neutral-700 mb-5" style={{ fontSize: '16px', lineHeight: 1.6 }}>
        Two of our travel insurers let you quote and buy directly online.
      </p>

      <div className="flex flex-wrap gap-3 mb-4">
        <Button
          className="bg-cta hover:bg-cta-hover hover:shadow-md transition-all duration-200"
          asChild
        >
          <a href="https://b2c.advisormax.ca/a045" target="_blank" rel="noopener" data-testid="travel-quote-allianz">
            Quote with Allianz
          </a>
        </Button>
        <Button
          className="bg-cta hover:bg-cta-hover hover:shadow-md transition-all duration-200"
          asChild
        >
          <a href="https://shop.tugo.com/store/FLE000" target="_blank" rel="noopener" data-testid="travel-quote-tugo">
            Quote with TuGo
          </a>
        </Button>
      </div>

      <p className="text-neutral-700 mb-6" style={{ fontSize: '16px', lineHeight: 1.6 }}>
        MSH Americas plans are not available online. If you&apos;d like us to include MSH in your
        comparison, or you want help choosing between plans,{' '}
        <a href="/contact-us" className="text-cta hover:text-cta-hover hover:underline" data-testid="travel-quote-contact">
          contact us
        </a>{' '}
        and we&apos;ll quote it for you.
      </p>

      <div className="border-t border-neutral-200 pt-5" data-testid="travel-quote-disclosure">
        <p className="text-neutral-700" style={{ fontSize: '16px', lineHeight: 1.6 }}>
          <strong>Before you buy online.</strong> These links take you to the insurer&apos;s own
          website, where you complete the purchase directly with them. We do not review your
          application and we do not provide advice on an online purchase. Travel medical coverage
          depends on your health when you buy and when you leave. Most policies apply a stability
          period to pre-existing conditions, and an incorrect answer on the medical questionnaire
          can void your coverage. Read the questionnaire and the policy wording carefully. If you
          have any medical history, or you are not sure how to answer a question, stop and contact
          us and we will walk you through it. John Fleming Insurance receives compensation from the
          insurer when a policy is purchased through these links.
          {superVisa ? ' You are responsible for confirming that the policy you buy meets the current IRCC Super Visa requirements.' : ''}
        </p>
      </div>
    </div>
  );
};

export default TravelQuoteOnline;
